import { Link } from "react-router-dom";
import { FaLinkedinIn, FaXTwitter, HiOutlineArrowUpRight } from "../components/common/LightIcons";
import { services } from "../data/siteData";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid-bg" />
      <div className="shell">
        <div className="footer-top">
          <div className="footer-brand-col">
            <Link to="/" className="brand brand-footer">
              <span className="brand-mark"><img src={require("../assets/HomePage/images/Navastha.jpg")} alt="Navastha Infotech" /></span>
              <span className="brand-copy"><strong>Navastha</strong><small>INFOTECH</small></span>
            </Link>
            <p>We design and engineer digital products, platforms and software teams for ambitious businesses.</p>
            <div className="footer-socials">
              <a href="https://www.linkedin.com/company/navastha-infotech/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn/></a>
              <a href="https://twitter.com/Navasthainfo" target="_blank" rel="noreferrer" aria-label="X"><FaXTwitter/></a>
            </div>
          </div>
          <div className="footer-col"><h4>Services</h4>{services.slice(0,5).map(s => <Link key={s.slug} to={`/services/${s.slug}`}>{s.title}</Link>)}</div>
          <div className="footer-col"><h4>Company</h4><Link to="/about">About us</Link><Link to="/portfolio">Our work</Link><Link to="/blogs">Insights</Link><Link to="/contact">Contact</Link></div>
          <div className="footer-col contact-col"><h4>Start a project</h4><a href="mailto:info@navasthainfotech.com">info@navasthainfotech.com <HiOutlineArrowUpRight/></a><a href="tel:+919929572110">+91 99295 72110</a><p>100-A, Main Karni Palace Rd, Vaishali Nagar, Jaipur, Rajasthan 302034</p></div>
        </div>
        <div className="footer-bottom"><span>© {new Date().getFullYear()} Navastha Infotech Pvt. Ltd.</span><span>Jaipur, India · Building for clients worldwide.</span></div>
      </div>
    </footer>
  );
}
